// ⚠️ AUTO-GENERATED: This file is managed by generateThemeRegistry.js
// Last updated: 2025-10-30T12:33:38.462Z
// Do not edit manually - changes will be overwritten
//
// This file contains theme definitions extracted from Themes.css
// for use in production environments where direct CSS access is unreliable.

/**
 * Theme Registry
 * Generated from CSS theme definitions in Themes.css
 */
export const THEME_REGISTRY = {
  "light-grayscale": {
    "name": "light-grayscale",
    "displayName": "Light",
    "themeColor": "snow",
    "themeSecondaryColor": "#e0e0e0",
    "primaryTextColor": "#000000",
    "frameBorderColor": "#a7a7a7",
    "secondaryTextColor": "#666666",
    "attentionColor": "#060606",
    "accentColor": "#b7b7b7",
    "warningColor": "#ff8800",
    "isDark": false,
    "category": "mono"
  },
  "dark-grayscale": {
    "name": "dark-grayscale",
    "displayName": "Dark",
    "themeColor": "#080808",
    "themeSecondaryColor": "#202020",
    "primaryTextColor": "#f2f2f2",
    "frameBorderColor": "#585858",
    "secondaryTextColor": "#cccccc",
    "attentionColor": "#f7f7f7",
    "accentColor": "#484848",
    "warningColor": "#ff8800",
    "isDark": true,
    "category": "mono"
  },
  "light-mono-red": {
    "name": "light-mono-red",
    "displayName": "Mono Red",
    "themeColor": "#ffe6e6",
    "themeSecondaryColor": "#ffb3b3",
    "primaryTextColor": "#000000",
    "frameBorderColor": "#ff9999",
    "secondaryTextColor": "#666666",
    "attentionColor": "#990000",
    "accentColor": "#ffe6e6",
    "warningColor": "#ff8800",
    "isDark": false,
    "category": "mono"
  },
  "dark-mono-red": {
    "name": "dark-mono-red",
    "displayName": "Mono Red",
    "themeColor": "#1a0000",
    "themeSecondaryColor": "#4d0000",
    "primaryTextColor": "#ffcccc",
    "frameBorderColor": "#660000",
    "secondaryTextColor": "#ff9999",
    "attentionColor": "#ff6666",
    "accentColor": "#990000",
    "warningColor": "#ff2222",
    "isDark": true,
    "category": "mono"
  },
  "light-mono-green": {
    "name": "light-mono-green",
    "displayName": "Mono Green",
    "themeColor": "#e6f7e6",
    "themeSecondaryColor": "#b3e0b3",
    "primaryTextColor": "#000000",
    "frameBorderColor": "#99dd99",
    "secondaryTextColor": "#666666",
    "attentionColor": "#006600",
    "accentColor": "#66ee66",
    "warningColor": "#009900",
    "isDark": false,
    "category": "mono"
  },
  "dark-mono-green": {
    "name": "dark-mono-green",
    "displayName": "Mono Green",
    "themeColor": "#001100",
    "themeSecondaryColor": "#003300",
    "primaryTextColor": "#ccffcc",
    "frameBorderColor": "#004400",
    "secondaryTextColor": "#99dd99",
    "attentionColor": "#00cc00",
    "accentColor": "#006600",
    "warningColor": "#00ee00",
    "isDark": true,
    "category": "mono"
  },
  "light-mono-blue": {
    "name": "light-mono-blue",
    "displayName": "Mono Blue",
    "themeColor": "#e6eef7",
    "themeSecondaryColor": "#b3d0e0",
    "primaryTextColor": "#000000",
    "frameBorderColor": "#99bbdd",
    "secondaryTextColor": "#666666",
    "attentionColor": "#003399",
    "accentColor": "#6699cc",
    "warningColor": "#0066cc",
    "isDark": false,
    "category": "mono"
  },
  "dark-mono-blue": {
    "name": "dark-mono-blue",
    "displayName": "Dark Monochrome Blue",
    "themeColor": "#000011",
    "themeSecondaryColor": "#001144",
    "primaryTextColor": "#ccddff",
    "frameBorderColor": "rgb(14, 42, 183)",
    "secondaryTextColor": "#99bbdd",
    "attentionColor": "#0066ff",
    "accentColor": "#003399",
    "warningColor": "#3399ff",
    "isDark": true,
    "category": "mono"
  },
  "custom": {
    "name": "custom",
    "displayName": "Custom",
    "themeColor": "hsl(var(--base-hue), 50%, calc(90% - (var(--is-dark-mode, 0) * 83%)))",
    "themeSecondaryColor": "hsl(var(--base-hue), 50%, calc(75% - (var(--is-dark-mode, 0) * 55%)))",
    "primaryTextColor": "hsl(0, 0%, calc(20% + (var(--is-dark-mode, 0) * 70%)))",
    "frameBorderColor": "hsl(var(--base-hue), 50%, calc(70% - (var(--is-dark-mode, 0) * 43%)))",
    "secondaryTextColor": "hsl(0, 0%, calc(33% + (var(--is-dark-mode, 0) * 47%)))",
    "attentionColor": "hsl(var(--base-hue), 70%, calc(30% + (var(--is-dark-mode, 0) * 20%)))",
    "accentColor": "hsl(var(--base-hue), 50%, calc(60% - (var(--is-dark-mode, 0) * 20%)))",
    "warningColor": "hsl(var(--base-hue), 60%, calc(40% - (var(--is-dark-mode, 0) * 20%)))",
    "isDark": false,
    "category": "custom"
  },
  "dark-only-dark-red": {
    "name": "dark-only-dark-red",
    "displayName": "Astron",
    "themeColor": "#200000",
    "themeSecondaryColor": "#350000",
    "primaryTextColor": "#ffcccc",
    "frameBorderColor": "#770000",
    "secondaryTextColor": "#ffdddd",
    "attentionColor": "#cc0000",
    "accentColor": "#800000",
    "warningColor": "#cc0000",
    "isDark": true,
    "category": "polychrome"
  },
  "dark-only-dark-green": {
    "name": "dark-only-dark-green",
    "displayName": "Night Vision",
    "themeColor": "#010c01",
    "themeSecondaryColor": "#012301",
    "primaryTextColor": "#66BF2F",
    "frameBorderColor": "#439413",
    "secondaryTextColor": "rgb(82, 172, 30)",
    "attentionColor": "#55e302",
    "accentColor": "#2C540F",
    "warningColor": "#439413",
    "isDark": true,
    "category": "polychrome"
  },
  "dark-only-dark-amber": {
    "name": "dark-only-dark-amber",
    "displayName": "Amber Monitor",
    "themeColor": "#1f1f1f",
    "themeSecondaryColor": "#333300",
    "primaryTextColor": "#ffcc00",
    "frameBorderColor": "#b38f00",
    "secondaryTextColor": "#ffdd33",
    "attentionColor": "#ffcc00",
    "accentColor": "#b38f00",
    "warningColor": "#ff9900",
    "isDark": true,
    "category": "polychrome"
  },
  "dark-monochrome-green": {
    "name": "dark-monochrome-green",
    "displayName": "Monochrome Green",
    "themeColor": "#1B3409",
    "themeSecondaryColor": "#375F1B",
    "primaryTextColor": "silver",
    "frameBorderColor": "#447521",
    "secondaryTextColor": "#b0b0b0",
    "attentionColor": "#ff0000",
    "accentColor": "#9BD770",
    "warningColor": "#447521",
    "isDark": true,
    "category": "mono"
  },
  "light-cs": {
    "name": "light-cs",
    "displayName": "Light Colour Safe",
    "themeColor": "#eeeebb",
    "themeSecondaryColor": "#ccddaa",
    "primaryTextColor": "#121212",
    "frameBorderColor": "whitesmoke",
    "secondaryTextColor": "black",
    "attentionColor": "#ff9999",
    "accentColor": "#eeeebb",
    "warningColor": "#ffcccc",
    "isDark": false,
    "category": "polychrome"
  },
  "dark-cs": {
    "name": "dark-cs",
    "displayName": "Dark Colour Safe",
    "themeColor": "#666633",
    "themeSecondaryColor": "#444422",
    "primaryTextColor": "#e6e6e6",
    "frameBorderColor": "#444422",
    "secondaryTextColor": "lightgrey",
    "attentionColor": "#ff9999",
    "accentColor": "#222255",
    "warningColor": "#666633",
    "isDark": true,
    "category": "polychrome"
  },
  "light-muted": {
    "name": "light-muted",
    "displayName": "Light Muted",
    "themeColor": "#DDCC77",
    "themeSecondaryColor": "#999933",
    "primaryTextColor": "#000000",
    "frameBorderColor": "#cccccc",
    "secondaryTextColor": "#666666",
    "attentionColor": "#ff0000",
    "accentColor": "#660000",
    "warningColor": "#ffcccc",
    "isDark": false,
    "category": "polychrome"
  },
  "dark-muted": {
    "name": "dark-muted",
    "displayName": "Dark Muted",
    "themeColor": "#332288",
    "themeSecondaryColor": "#882255",
    "primaryTextColor": "white",
    "frameBorderColor": "#cccccc",
    "secondaryTextColor": "lightgrey",
    "attentionColor": "#ff0000",
    "accentColor": "#b3b3ff",
    "warningColor": "#663333",
    "isDark": true,
    "category": "polychrome"
  },
  "dark-forest": {
    "name": "dark-forest",
    "displayName": "Dark Forest",
    "themeColor": "#083205",
    "themeSecondaryColor": "#122306",
    "primaryTextColor": "#96D569",
    "frameBorderColor": "#447521",
    "secondaryTextColor": "#71C337",
    "attentionColor": "#96D569",
    "accentColor": "#447521",
    "warningColor": "#71C337",
    "isDark": true,
    "category": "polychrome"
  },
  "light-forest": {
    "name": "light-forest",
    "displayName": "Light Forest",
    "themeColor": "#96D569",
    "themeSecondaryColor": "#71C337",
    "primaryTextColor": "#083205",
    "frameBorderColor": "#447521",
    "secondaryTextColor": "#122306",
    "attentionColor": "#083205",
    "accentColor": "#447521",
    "warningColor": "#1C300D",
    "isDark": false,
    "category": "polychrome"
  },
  "light-tol-muted": {
    "name": "light-tol-muted",
    "displayName": "Muted",
    "themeColor": "#f8f8f8",
    "themeSecondaryColor": "#88CCEE",
    "primaryTextColor": "#332288",
    "frameBorderColor": "#DDCC77",
    "secondaryTextColor": "#882255",
    "attentionColor": "#AA4499",
    "accentColor": "#44AA99",
    "warningColor": "#CC6677",
    "isDark": false,
    "category": "polychrome"
  },
  "dark-tol-muted": {
    "name": "dark-tol-muted",
    "displayName": "Muted",
    "themeColor": "#2a2a2a",
    "themeSecondaryColor": "#e0e0e0",
    "primaryTextColor": "#DDCC77",
    "frameBorderColor": "#44AA99",
    "secondaryTextColor": "#88CCEE",
    "attentionColor": "#88CCEE",
    "accentColor": "#44AA99",
    "warningColor": "#CC6677",
    "isDark": true,
    "category": "polychrome"
  },
  "light-modern": {
    "name": "light-modern",
    "displayName": "Modern Light",
    "themeColor": "#F7F9FC",
    "themeSecondaryColor": "#D5E8F7",
    "primaryTextColor": "#2C3E50",
    "frameBorderColor": "#D5DBDB",
    "secondaryTextColor": "#5D6D7E",
    "attentionColor": "#8E44AD",
    "accentColor": "#5B9BD5",
    "warningColor": "#E67E22",
    "isDark": false,
    "category": "polychrome"
  },
  "dark-modern": {
    "name": "dark-modern",
    "displayName": "Modern Dark",
    "themeColor": "#212F3D",
    "themeSecondaryColor": "#34495E",
    "primaryTextColor": "#EAEDED",
    "frameBorderColor": "#566573",
    "secondaryTextColor": "#D5DBDB",
    "attentionColor": "#AF7AC5",
    "accentColor": "#5DADE2",
    "warningColor": "#F39C12",
    "isDark": true,
    "category": "polychrome"
  },
  "dark-only-dark-rust": {
    "name": "dark-only-dark-rust",
    "displayName": "Rust",
    "themeColor": "#36241F",
    "themeSecondaryColor": "#6D2809",
    "primaryTextColor": "#f8f6f0ff",
    "frameBorderColor": "#C28840",
    "secondaryTextColor": "#C28840",
    "attentionColor": "#DFB072",
    "accentColor": "#8C462C",
    "warningColor": "#E67E22",
    "isDark": true,
    "category": "polychrome"
  },
  "light-ocean": {
    "name": "light-ocean",
    "displayName": "Ocean Light",
    "themeColor": "#E5E1DC",
    "themeSecondaryColor": "#D2CCC3",
    "primaryTextColor": "#26789E",
    "frameBorderColor": "#004D40",
    "secondaryTextColor": "#002639",
    "attentionColor": "#00838F",
    "accentColor": "#80D8C4",
    "warningColor": "#FF7043",
    "isDark": false,
    "category": "polychrome"
  },
  "dark-ocean": {
    "name": "dark-ocean",
    "displayName": "Ocean Dark",
    "themeColor": "#002639",
    "themeSecondaryColor": "#003F5C",
    "primaryTextColor": "#B2DFDB",
    "frameBorderColor": "#00838F",
    "secondaryTextColor": "#E0F2F1",
    "attentionColor": "#4FC4B8",
    "accentColor": "#00838F",
    "warningColor": "#FF7043",
    "isDark": true,
    "category": "polychrome"
  },
  "light-savannah": {
    "name": "light-savannah",
    "displayName": "Savannah Light",
    "themeColor": "#DDD2BD",
    "themeSecondaryColor": "#C89E79",
    "primaryTextColor": "#5A4B3A",
    "frameBorderColor": "#5A4B3A",
    "secondaryTextColor": "#714117",
    "attentionColor": "#4A5141",
    "accentColor": "#D7B49E",
    "warningColor": "#D2691E",
    "isDark": false,
    "category": "polychrome"
  },
  "dark-savannah": {
    "name": "dark-savannah",
    "displayName": "Savannah Dark",
    "themeColor": "#654324",
    "themeSecondaryColor": "#714117",
    "primaryTextColor": "#D7B49E",
    "frameBorderColor": "#D7B49E",
    "secondaryTextColor": "#D4A056",
    "attentionColor": "#EACB92",
    "accentColor": "#7E6033",
    "warningColor": "#D2691E",
    "isDark": true,
    "category": "polychrome"
  },
  "light-autumn": {
    "name": "light-autumn",
    "displayName": "Autumn",
    "themeColor": "#FFF8DC",
    "themeSecondaryColor": "#ccDAB9",
    "primaryTextColor": "#8B4513",
    "frameBorderColor": "#8B4513",
    "secondaryTextColor": "#D2691E",
    "attentionColor": "#FF4500",
    "accentColor": "#CD853F",
    "warningColor": "#FF6347",
    "isDark": false,
    "category": "polychrome"
  },
  "dark-autumn": {
    "name": "dark-autumn",
    "displayName": "Autumn",
    "themeColor": "#333300",
    "themeSecondaryColor": "#2a331a",
    "primaryTextColor": "#cca300",
    "frameBorderColor": "#8B4513",
    "secondaryTextColor": "#FF8C00",
    "attentionColor": "#FFD700",
    "accentColor": "#8B4513",
    "warningColor": "#FF6347",
    "isDark": true,
    "category": "polychrome"
  },
  "dark-only-vs-dark": {
    "name": "dark-only-vs-dark",
    "displayName": "Visual Studio Dark",
    "themeColor": "#252526",
    "themeSecondaryColor": "#2D2D30",
    "primaryTextColor": "#D4D4D4",
    "frameBorderColor": "#444444",
    "secondaryTextColor": "#9CDCFE",
    "attentionColor": "#569CD6",
    "accentColor": "#007ACC",
    "warningColor": "#CD9731",
    "isDark": true,
    "category": "vs"
  },
  "light-only-vs-light": {
    "name": "light-only-vs-light",
    "displayName": "Visual Studio Light",
    "themeColor": "#F5F5F5",
    "themeSecondaryColor": "#EEEEF2",
    "primaryTextColor": "#000000",
    "frameBorderColor": "#CCCEDB",
    "secondaryTextColor": "#1F377F",
    "attentionColor": "#1B1B1B",
    "accentColor": "#0078D7",
    "warningColor": "#CA5100",
    "isDark": false,
    "category": "vs"
  },
  "dark-only-dark-monokai": {
    "name": "dark-only-dark-monokai",
    "displayName": "VS Monokai",
    "themeColor": "#1E1F1C",
    "themeSecondaryColor": "#414339",
    "primaryTextColor": "#F8F8F2",
    "frameBorderColor": "#57564bff",
    "secondaryTextColor": "#A6E22E",
    "attentionColor": "#66D9EF",
    "accentColor": "#FD971F",
    "warningColor": "#F92672",
    "isDark": true,
    "category": "vs"
  },
  "dark-only-dark-vs-solarized": {
    "name": "dark-only-dark-vs-solarized",
    "displayName": "Solarized Dark",
    "themeColor": "#00212B",
    "themeSecondaryColor": "#003540",
    "primaryTextColor": "#839496",
    "frameBorderColor": "#073642",
    "secondaryTextColor": "#2AA198",
    "attentionColor": "#2AA198",
    "accentColor": "#268BD2",
    "warningColor": "#CB4B16",
    "isDark": true,
    "category": "vs"
  }
};

/**
 * Get themes organized by category
 * @returns {Object} Object with arrays of themes by category
 */
export const getThemesByCategory = () => {
  const categories = {
    mono: [],
    vs: [],
    polychrome: [],
    custom: []
  };
  
  Object.values(THEME_REGISTRY).forEach(theme => {
    if (categories[theme.category]) {
      categories[theme.category].push(theme);
    }
  });
  
  return categories;
};

/**
 * Get theme information by name
 * @param {string} themeName - Name of the theme to retrieve
 * @returns {Object|undefined} Theme object or undefined if not found
 */
export const getThemeByName = (themeName) => {
  return THEME_REGISTRY[themeName];
};
